import React from 'react'
import { toast } from "react-toastify";
import { Link } from 'react-router-dom'
import RV from 'simple-react-validator';
import ls from 'local-storage'
import * as CONFIG from './_config';
import ReCAPTCHA from "react-google-recaptcha";

toast.configure()
const axios = require('axios');

class Login extends React.Component {

    constructor(props) {
        super(props);
        this.validator = new RV();
        this.state = {
            formControls: []
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
        }
    }

    changeHandler = (event) => {

        const name = event.target.name;
        const value = event.target.value;

        this.setState({
            formControls: {
                ...this.state.formControls,
                [name]: value
            }

        });
        // console.log(this.state.formControls);
    }

    Forget = async (e) => {
        // console.log(this.state);
        e.preventDefault();

        if (!this.validator.allValid()) {
            this.validator.showMessages();
            this.forceUpdate();
            return false;
        }

        var apiurl;
        const data = new FormData();
        data.append('method', 'POST');
        // eslint-disable-next-line no-lone-blocks
        {
            CONFIG.DATA.ALLOW_PASSWORD|| CONFIG.DATA.RSA_SUBDOMAIN === 'lowesfoodking' ||
                CONFIG.DATA.RSA_SUBDOMAIN === 'lowesmarket' || CONFIG.DATA.RSA_SUBDOMAIN === 'lowessupersave'
                || CONFIG.DATA.RSA_SUBDOMAIN === 'lowessignature' || CONFIG.DATA.RSA_SUBDOMAIN === 'superiorgrocers' ||
                CONFIG.DATA.RSA_SUBDOMAIN === 'market33' || CONFIG.DATA.RSA_SUBDOMAIN === 'fiestafoodsamarillo' ||
                CONFIG.DATA.RSA_SUBDOMAIN === 'topvaluecostplus' || CONFIG.DATA.RSA_SUBDOMAIN === 'pandlcountrymarket' ||
                CONFIG.DATA.RSA_SUBDOMAIN === 'bradfordgeneralstore' || CONFIG.DATA.RSA_SUBDOMAIN === 'lagreesfoodstores' ||
                CONFIG.DATA.RSA_SUBDOMAIN === 'mcdanielpw' || CONFIG.DATA.RSA_SUBDOMAIN === 'kirbyfoods' ||
                CONFIG.DATA.RSA_SUBDOMAIN === "vowellsmarketplace" || CONFIG.DATA.RSA_SUBDOMAIN === "sandssupermarket"||CONFIG.DATA.RSA_SUBDOMAIN==='bakerfoodspw'?

                apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/ForgotPasswordV2` :
                //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/ForgotPasswordV2`) :
                apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/ForgotPassword`;
                //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/ForgotPassword`);

        }

        data.append('UserName', this.state.formControls.username);
        var object = {};
        data.forEach((value, key) => (object[key] = value));
        var jsonData = JSON.stringify(object);

        axios
        .post(apiurl, jsonData, {
            headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
        })

        
            .then((res) => {
                if (res.data.ErrorMessage.ErrorCode <= 0) {
                    toast.error(res.data.ErrorMessage.ErrorDetails);
                } else {
                    toast.success("An email has been sent!", { autoClose: 7000 });

                    let redirectToPath = window.location.pathname;

                    if (window.location.hash !== '')
                        redirectToPath = redirectToPath + window.location.hash;

                    // ls.set('redirectTo', redirectToPath);
                    this.props.history.push("/login");

                }
            })
            .catch(function (ress) {
                console.log(ress);
                toast.error("Error Notification !");

            });
    };
    handleChange = value => {
        // console.log("Captcha value:", value);
        this.setState({
            formControls: { ...this.state.formControls, ['Captcha']: value }
        });
    };


    render() {

        return (
            <div>
                <div className="main-container full-width mt-2 pt-2">
                    {CONFIG.DATA.THEME === 2 ?
                        <div>
                            {CONFIG.DATA.BACKEND_HOST === 'foodbazaar' ?
                                ''
                                :
                                <section id="apus-breadscrumb" className="breadcrumb-page apus-breadscrumb" style={{ backgroundColor: '#f3ffd9' }}>
                                    <div className="container">
                                        <div className="wrapper-breads">
                                            <div className="wrapper-breads-inner">
                                                <div className="breadscrumb-inner">
                                                    <h2 className="bread-title">{CONFIG.DATA.ALLOW_PASSWORD|| CONFIG.DATA.RSA_SUBDOMAIN ===
                                      "sandssupermarket" ||CONFIG.DATA.RSA_SUBDOMAIN==='bakerfoodspw'?'Forgot Password':'Forgot Pin'}</h2>
                                                    <ol className="breadcrumb">
                                                        <li>
                                                            <a href={CONFIG.DATA.BASEPATH}>Home</a>
                                                        </li>
                                                        <li>
                                                            <span>{CONFIG.DATA.ALLOW_PASSWORD || CONFIG.DATA.RSA_SUBDOMAIN ===
                                      "sandssupermarket" ||CONFIG.DATA.RSA_SUBDOMAIN==='bakerfoodspw' ?'Forgot Password':'Forgot Pin'}</span>
                                                        </li>
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            }
                        </div>
                        :
                        <div className="title-breadcrumb">
                            <div className="container">
                                <div className="title-breadcrumb-inner">
                                    <header className="entry-header">
                                        <h1 className="entry-title">{CONFIG.DATA.ALLOW_PASSWORD|| CONFIG.DATA.RSA_SUBDOMAIN ===
                                      "sandssupermarket" ||CONFIG.DATA.RSA_SUBDOMAIN==='bakerfoodspw' ?'Forgot Password':'Forgot Pin'}</h1>
                                    </header>
                                    <div className="breadcrumbs">
                                        <Link to="/">Home</Link>
                                        <span className="separator">/</span>
                                        <span> {CONFIG.DATA.ALLOW_PASSWORD|| CONFIG.DATA.RSA_SUBDOMAIN ===
                                      "sandssupermarket" ||CONFIG.DATA.RSA_SUBDOMAIN==='bakerfoodspw'?'Forgot Password':'Forgot Pin'}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {CONFIG.DATA.BACKEND_HOST === 'foodbazaar' ?
                        <>
                            <img src="/assets/images/food_bazaar_log_n_image.svg" style={{ height: "180px" }} alt="Foodbazaar" />
                        </>
                        : ''
                    }
                    <div className="col-md-4 offset-md-4 pt-4">
                        {CONFIG.DATA.BACKEND_HOST === 'foodbazaar' ?
                            <div className="card">
                                <div className="card-body">
                                    <h3 style={{ fontWeight: '400' }}>Forget Pin</h3>
                                </div>
                            </div>
                            : ''
                        }
                        <div className="page-content border pt-3">
                            <div className="container">
                                <article id="post-22" className="post-22 page type-page status-publish hentry">
                                    <div className="entry-content forgetpin">
                                        <div className="woocommerce">
                                            <div className="woocommerce-notices-wrapper" />
                                            <form method="post" className="login" >
                                                <div className="form-group form-row form-row-wide">
                                                    <label htmlFor="username">
                                                        Username or Email Address{" "}
                                                        <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="input-text form-control"
                                                        name="username"
                                                        id="username"
                                                        onChange={(e) => this.changeHandler(e)}
                                                    />
                                                    <div className='text-danger'>{this.validator.message('Email', this.state.formControls.username, 'required|email')}</div>
                                                </div>
                                                <div className="form-group form-row">
                                                    <input
                                                        type="hidden"
                                                        id="woocommerce-login-nonce"
                                                        name="woocommerce-login-nonce"
                                                        defaultValue="17d498475e"
                                                    />
                                                    <div className="form-group clearfix">
                                                        {/*<span for="rememberme" class="inline pull-left">
						<input name="rememberme" type="checkbox" id="rememberme" value="forever"> Remember me					</span>*/}
                                                    </div>

                                                    <div className='ReCAPTCHA ' style={{ margin: 'auto' }}>

                                                        <ReCAPTCHA
                                                            style={{ display: "block" }}
                                                            theme="light"
                                                            sitekey="6LebzrYUAAAAAIo_0vP7bjbtzzBTKNlC4UvyEGKU"
                                                            onChange={this.handleChange}
                                                            asyncScriptOnLoad={this.asyncScriptOnLoad}
                                                        />
                                                        <div className='text-danger text-center'>{this.validator.message('captcha', this.state.formControls.Captcha, 'required')}</div>
                                                    </div>


                                                    <input
                                                        type="button"
                                                        id="forget_pin_button"
                                                        className="btn btn-theme btn-block woocommerce-Button button"
                                                        name="login"
                                                        defaultValue="Submit"
                                                        onClick={e => this.Forget(e)} />

                                                </div>

                                                <p className="woocommerce-LostPassword lost_password">OR</p>
                                                <p className="woocommerce-LostPassword lost_password">
                                                    <Link to='/login' className="float-left ml-5" >Login</Link>
                                                    <Link to={CONFIG.DATA.ALLOW_LINK_CARD_REGISTRATION ? "/register" : "/simple-register"} className="float-right mr-5">
                                                        Create an Account
                                                    </Link>
                                                </p>
                                            </form>
                                        </div>
                                    </div>
                                </article>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


        );
    }
}
export default Login;



